import { createBrowserRouter } from "react-router-dom";
import Blog from "../components/Blog";
import Category from "../components/Category";
import Checkout from "../components/Checkout";
import Errorpage from "../components/Errorpage";
import Home from "../components/Home";
import Login from "../components/Login";
import Signupform from "../components/Signupform";
import Tutorials from "../components/Tutorials";
import Main from "../Layouts/Main";
import Privateroute from "./Privateroute";

 export const routes=createBrowserRouter([
    {
        path:'/',
        element:<Main></Main>,
        errorElement:<Errorpage></Errorpage>,
        children:[
            {
                path:'/',
                element:<Home></Home>
            },
            {
                path:'/home',
                element:<Home></Home>
            },
            {
             path:'/categories/:id',
             element:<Category></Category>,
             loader:({params})=>fetch(`https://education-site-server.vercel.app/category/${params.id}`)
            },
            {
                path: '/tutorials/:id',
                element:<Tutorials></Tutorials> ,
                loader: ({params}) => fetch(`https://education-site-server.vercel.app/tutorials/${params.id}`)
            },
            {
              path:'/blog',
              element:<Blog></Blog>
            },
            {
                path:'/login',
                element:<Login></Login>
            },
               {
               path:'/signup',
               element:<Signupform></Signupform>
               },
               {
                path:'/checkout',
                element:<Privateroute><Checkout></Checkout></Privateroute>,
               }
        ]
    }
])